import { Plugins } from '@bimser/studio-core';

export function getResultData(
	response: Plugins.QueryDesigner.Entities.Bases.IDataSourceResponse
): any[] {
	return response?.result || null;
}
